module.exports = __webpack_public_path__ + "img/logo-itb.21657895.png";